export enum AwardCategory {
  WiseArtsChoice = "wise-arts-choice",
  PhygitalWinner = "phygital-winner",
  DigitalWinner = "digital-winner",
  CollectiveWinner = "collective-winner",
  PhotographyWinner = "photography-winner",
}
